export enum UpsellType {
  MultiProducts = 'multiProducts',
  PlanComparison = 'planComparison',
  TrafficRecommendation = 'trafficRecommendation',
  PlansAndBillingRedirection = 'plansAndBillingRedirection',
}

export enum DatadogUpsellType {
  PostTrial = 'PostTrial',
  PlanComparison = 'PlanComparison',
  TrafficRecommendation = 'TrafficRecommendation',
  PlansAndBillingRedirection = 'PlansAndBillingRedirection',
  MultiProductWrapper = 'MultiProductWrapper',
}

export enum DatadogActionType {
  Trigger = 'trigger', // An upsell was triggered, but the modal didn't open yet
  Open = 'open', // The upsell modal opened
  Failure = 'failure', // An error happened in the upsell flow
}
